import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { ObservableService } from '../../services/observable-service';
import { MetaTagService } from '../../services/meta-tag-service'

import { UserService } from '../../services/user-service';

@Component({
  selector: 'app-business-change-login',
  templateUrl: './business-change-login.page.html',
  styleUrls: ['./business-change-login.page.scss'],
})
export class BusinessChangeLoginPage implements OnInit {

  	constructor(
		private metaTagService: MetaTagService,
		private observables: ObservableService,
		private userService: UserService,
  	) {}

  	ngOnInit() {}

    ionViewWillEnter() {
      this.metaTagService.updateTitle('Change Account | Shortcut Pros')
    }

  	ionViewWillLeave() {
  	}


	logOut() {
		this.userService.logout()
		this.observables.publishLogOut()
	}
}
